export default function IsMapZoomedToLayerMinZoom (mapZ, minZoom) {
  const mapZRoundedUp = Math.round(mapZ) // On mobile devices zoom can be a decimal. E.g. 15.3
  return mapZRoundedUp >= minZoom
}
